<div role="button" tabindex="0" class="agent-wrapper has-pos-rel" [class.luxury]="isLuxury" (click)="goToAgent()" (keydown.enter)="goToAgent($event, cardRef)" #cardRef>
  <div [jsonSchema]="agent.jsonLdSchema"></div>
  <span class="title has-pos-abs text-center" *ngIf="agent.title && includeTitle">{{agent.title}}</span>
  <div class="agent-card">
    <div class="thumbnail" [class.no-photo]="shouldShowInitials">
      <a [routerLink]="[agent.detailUrl]" [title]="'contact.aria.viewProfile' | translate" [class.outline]="!shouldShowInitials" tabindex="-1">
        <img class="img lazypreload lazyload" *ngIf="!shouldShowInitials" [url]="agent.associatePhoto" width="140" height="200"
        [imageQualityPercentage]="isLDP ? 100 : 0" keepAspectRatio="true" [alt]="'contact.aria.agentPicture' | translate" (error)="imgErrorHandler($event)" appImgLoader appImgIxImage>
        <app-circle-initials *ngIf="shouldShowInitials" [initials]="agent.agentInitials"></app-circle-initials>
      </a>
    </div>
    <div class="caption-1">
      <div class="name-rating is-flex has-flex-align-center">
        <a [routerLink]="[agent.detailUrl]" [title]="'contact.aria.viewProfile' | translate" [attr.aria-label]="'contact.aria.viewProfile' | translate" tabindex="-1">
          <h4 class="name wrap-word is-flex has-flex-align-center">{{ agent.firstName }} {{ agent.lastName }} {{agent.agentPrecTitle}} <i class="material-icons">chevron_right</i></h4>
        </a>
        <app-rating *ngIf="agentRating && agentRating.overall_rating && agentRating.overall_rating > 0" [setRating]="agentRating.overall_rating"></app-rating>
      </div>
      <div class="divider"></div>
      <p class="office" >{{ (agent.agentIncorporation && agent.agentIncorporation !== 'Personal Real Estate Corporation') ? agent.agentIncorporation : agent.officeName }}</p>
      <p class="agent-card__address">{{ agent.city }}, {{ agent.stateShort }}</p>
      <p class="contact is-flex has-flex-align-center">
        <app-card-contact-info [emailTitle]="'contact.aria.emailAgent'" [phoneTitle]="'contact.aria.callAgent'" [contactObject]="agent"
                               (onContactObjectClicked)="trackEmailClickAnalytics(); onAgentEmailClicked.emit(agent)"></app-card-contact-info>
      </p>
    </div>
    <div class="caption-2">
      <div class="contact-luxury full-width">
        <span *ngIf="agent.parsedPhoneNumber">{{ 'contact.ph' | translate }}: <b>{{ agent.parsedPhoneNumber }}</b></span>
        <div class="contact-button">
          <button class="btn btn-luxury" (click)="$event.stopPropagation();onContactAgent.emit(agent)">
            <span translate="contact.contact"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
